import { getFullUrl } from "@/modules/main/urls.ts";

export function getPaymentReturnUrl(): string {
    // NB: The URL must end with a slash since payment-api will literally append "hub/please_wait" to it
    return `${getFullUrl("/payment_return")}/`;
}
